import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const JoinUsHeroWrapper = styled.div<{ url: string }>`
  display: grid;
  align-items: center;

  grid-column: 1/-1;
  height: 100vh;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${colors.black};
  margin-bottom: 81px;
  grid-template-columns: inherit;
  grid-column-gap: inherit;

  ${({ url }) => css`
    background-image: url('${url}');
  `}

  & h1 {
    margin-bottom: 15px;
    grid-column: 2/-2;
  }

  ${mediaDesktop(css`
    margin-bottom: 161px;

    height: auto;
    background-size: cover;
  `)}
`;
